/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./links";
import routes from "../routes";

import logo from "../public/sanieldan-logo-1-768x144.png";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`fixed top-0 left-0 z-50 h-full w-50 transform bg-gradient-to-b from-indigo-700 to-purple-900 text-white shadow-lg transition-transform duration-300 ease-in-out ${
        open ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 flex items-center justify-center rounded-full bg-white p-2 text-indigo-700 shadow-md transition-transform hover:scale-105 focus:outline-none xl:hidden"
        onClick={onClose}
        aria-label="Close Sidebar"
      >
        <HiX className="text-xl" />
      </button>

      {/* Logo Section */}
      <div className="flex items-center justify-center py-8 bg-white">
        <img src={logo} alt="Logo" className="w-36" />
      </div>

      {/* Navigation Links */}
      <nav className="flex-grow">
        <ul className="space-y-1 ">
          <Links routes={routes} />
        </ul>
      </nav>

      {/* Footer Section */}
    
    </div>
  );
};

export default Sidebar;
